import ActivityTypeSelect from "./ActivityTypeSelect"
import SearchBar from "./SearchBar";
import CategorySlidebar from "./CategorySlidebar";
import { useEffect } from "react";
import { setIsAllFiltersOpen, setIsFixed, setIsPoolOpen } from "../../redux/searchbarSlice";
import { useDispatch, useSelector } from "react-redux";
import useWindowWidth from "../../hooks/useWindowWidth";
import useScrollPosition from "../../hooks/useScrollPosition";
import AllFilters from "./AllFilters";
import { useTranslation } from "react-i18next";

const Pool = () => {
    const {t} = useTranslation();

    // Gestisco l'apertura/chiusura della Pool in AllActivities
    const windowWidth = useWindowWidth();
    const { whichPage, isPoolOpen, isFixed, isAllFiltersOpen } = useSelector(state => state.searchbar);
    const dispatch = useDispatch();
    useEffect(() => {
        if (whichPage === 'AllActivities') {
            dispatch(setIsPoolOpen(false))
        }
        if (whichPage === 'HomePage') {
            dispatch(setIsPoolOpen(true))
            dispatch(setIsAllFiltersOpen(false))
        }
    }, [whichPage, dispatch])

    const handleSetPool = (boo) => {
        dispatch(setIsPoolOpen(boo))
    }

    // Imposto isFixed in Redux se lo scroll supera i 300px
    const scrollPosition = useScrollPosition();
    useEffect(() => {
        if (scrollPosition > 300) {
            dispatch(setIsFixed(true))
        } else {
            dispatch(setIsFixed(false))
        }
    }, [scrollPosition, dispatch])

    return (
        <div className={`w-full z-20 ${whichPage === 'HomePage' && 'bg-transparent'} ${whichPage === 'AllActivities' && 'bg-[#f7f7f8]'} ${isFixed && ((whichPage === 'AllActivities' && windowWidth < 768) || whichPage === 'HomePage') && whichPage !== 'MapPage' && 'fixed top-0'} ${isFixed && whichPage === 'AllActivities' && 'shadow-xl'}`}>
            {
                isPoolOpen &&
                <div className="w-full flex flex-col items-center">
                    {
                        (whichPage === 'AllActivities' || whichPage === 'MapPage') &&
                        <div className="w-full flex justify-end p-4">
                            {
                                isFixed ? (
                                    <i className="fi fi-rr-circle-xmark text-black text-2xl cursor-pointer" onClick={() => dispatch(setIsPoolOpen(false))}></i>
                                ) : (
                                    <i className="fi fi-rr-angle-small-up text-black text-2xl cursor-pointer" onClick={() => dispatch(setIsPoolOpen(false))}></i>
                                )
                            }
                        </div>
                    }
                    {
                        (whichPage === 'AllActivities' || whichPage === 'MapPage') &&
                        < ActivityTypeSelect />
                    }
                    <SearchBar />
                    {
                        (whichPage === 'AllActivities' || whichPage === 'MapPage') &&
                        <CategorySlidebar />
                    }
                    {/* FILTERS BUTTON */}
                    {isAllFiltersOpen && <AllFilters />}
                    {
                        !isAllFiltersOpen && (whichPage === 'AllActivities' || whichPage === 'MapPage') &&
                        <div className="m-4 py-1 px-2 border rounded-xl cursor-pointer bg-neutral-100 hover:bg-[#e2eeed] flex gap-2 items-center text-sm" onClick={() => dispatch(setIsAllFiltersOpen(true))}>
                            <div className="mt-1"><i className="fi fi-rr-settings-sliders"></i></div>
                            <div>{t('poolBar.otherFiltersCopy')}</div>
                        </div>
                    }

                </div>
            }

            {/* Barra di ricerca chiusa */}
            {
                !isPoolOpen &&
                <div className={`${isFixed && windowWidth < 768 ? 'fixed top-24 rounded-r-xl' : 'rounded-xl'} left-0 z-10 bg-[#f7f7f8] py-2 pl-3 pr-4 border cursor-pointer flex gap-2 justify-center items-center`} onClick={() => handleSetPool(true)}>
                    {!isFixed && <div className="pt-2 mr-[-4px]"><i className="fi fi-rr-angle-small-down"></i></div>}
                    {!isFixed && <div>{t('poolBar.openBarCopy')}</div>}
                    <div className="pt-1"><i className="fi fi-br-search text-xl text-[#225424]"></i></div>
                </div>
            }
        </div>
    )
}

export default Pool